// assets/eg-booking-guard.js
// Failsafe-guard + submit-lock för EG booking
// - Stoppar /cart/add om det är en hyrprodukt men eg_quote_token saknas
// - Hindrar dubbel-submit (snabbklick/Enter) på samma form

(() => {
  "use strict";

  const DEBUG =
    localStorage.getItem("eg_debug_guard") === "1" ||
    window.__EG_DEBUG_GUARD__ === true;

  const log = (...a) => DEBUG && console.log("[EG guard]", ...a);

  function isCartAddForm(form) {
    const action = (form.getAttribute("action") || "").toLowerCase();
    return action.includes("/cart/add");
  }

  function isRentalScope(form) {
    // “Hyrprodukt” = har booking-root i samma sektion/kort, eller hidden booking-fält
    const scope =
      form.closest("[data-eg-rental-card]") ||
      form.closest(".shopify-section") ||
      form.closest("section") ||
      form.parentElement ||
      document;

    if (scope.querySelector("#eg-calendar-root[data-eg-booking], [data-eg-booking]")) return true;

    // fallback: har start/end inputs
    if (form.querySelector('input[name="eg_start_date"], input[name="eg_end_date"]')) return true;

    return false;
  }

  function getToken(form) {
    return (form.querySelector('input[name="eg_quote_token"]')?.value || "").trim();
  }

  function showInlineError(form, msg) {
    // Minimal inline-notis (ingen alert)
    const id = "eg-booking-guard-msg";
    let box = form.querySelector(`#${id}`);
    if (!box) {
      box = document.createElement("div");
      box.id = id;
      box.setAttribute("role", "alert");
      box.style.margin = "10px 0 0";
      box.style.fontSize = "14px";
      box.style.lineHeight = "1.35";
      box.style.padding = "10px 12px";
      box.style.borderRadius = "10px";
      box.style.background = "rgba(255, 0, 0, 0.08)";
      box.style.border = "1px solid rgba(255, 0, 0, 0.25)";
      form.appendChild(box);
    }
    box.textContent = msg;
  }

  function clearInlineError(form) {
    const box = form.querySelector("#eg-booking-guard-msg");
    if (box) box.remove();
  }

  // submit lock map
  const locked = new WeakSet();

  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!isCartAddForm(form)) return;
      if (!isRentalScope(form)) return;

      clearInlineError(form);

      // Prevent double-submit
      if (locked.has(form)) {
        e.preventDefault();
        e.stopPropagation();
        log("blocked double submit");
        return false;
      }

      const token = getToken(form);
      if (!token) {
        e.preventDefault();
        e.stopPropagation();

        showInlineError(
          form,
          "Kunde inte låsa bokningen ännu. Välj datum igen (eller vänta en sekund) så räknar vi ut pris och tillgänglighet."
        );

        log("blocked submit: missing token");
        return false;
      }

      // lock on allowed submit
      locked.add(form);

      // auto-unlock efter en stund (ifall redirect inte sker pga fel)
      setTimeout(() => locked.delete(form), 8000);
    },
    true // capture
  );

  // När en ny quote kommer in, släpp ev. lock och rensa felnotis (så användaren kan försöka igen)
  window.addEventListener("eg:quote", (e) => {
    const d = e.detail || {};
    const rootId = d.rootId || "eg-calendar-root";
    const rootEl = document.getElementById(rootId) || document.getElementById("eg-calendar-root") || document.querySelector("[data-eg-booking]");
    if (!rootEl) return;

    const form =
      rootEl.closest("[data-eg-rental-card]")?.querySelector("form[action*='/cart/add']") ||
      rootEl.closest("section")?.querySelector("form[action*='/cart/add']") ||
      document.querySelector("form[action*='/cart/add']");

    if (!form) return;

    // quote kan vara null (pending) eller error/OK
    if (d.quote && d.quote.token) {
      clearInlineError(form);
      locked.delete(form); // låt användaren submit:a igen om det behövs
    } else if (d.quote && d.quote.error) {
      locked.delete(form);
    }
  });
})();